import {
	DEV_API_BASE_URL,
	DEV_HUB_BASE_URL,
	PROD_API_BASE_URL,
	PROD_HUB_BASE_URL,
} from "@memorang/constants/urls";

export const IS_DEV = process.env.EXPO_PUBLIC_IS_DEV === "true";
export const IS_PRODUCTION = process.env.NODE_ENV === "production";

export const STRIPE_KEY = IS_DEV
	? process.env.EXPO_PUBLIC_STRIPE_KEY_TEST
	: process.env.EXPO_PUBLIC_STRIPE_KEY_LIVE;

export const HUB_BASE_URL = IS_DEV ? DEV_HUB_BASE_URL : PROD_HUB_BASE_URL;
export const API_BASE_URL = IS_DEV ? DEV_API_BASE_URL : PROD_API_BASE_URL;
